import React from 'react';
import PropTypes from 'prop-types';
import download from 'downloadjs';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import Collections from '@material-ui/icons/Collections';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';

import { S3_ENDPOINT } from '../../api/api';

const styles = {
  card: {
    maxWidth: 300,
  },
  media: {
    height: 150,
  },
  redAvatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: 'red',
  }
};


const Document = ({ doc, index, onRemoveSelectedEntryDocumentations, unAuthorized, classes }) => {
  const docName = doc.id ? doc.attachment_file_name : doc.name;
  const docLocation = doc.id ? `https:${doc.location}` : 'N/A';
  return (
    <Grid item xs={12}>
      <ListItem key={index} dense button className={classes.listItem} onClick={() => download(docLocation)}>
        <Avatar className={classes.redAvatar}>
          {doc.type === 'application/pdf' ? <PictureAsPdf /> : <Collections />}
        </Avatar>
        <ListItemText primary={docName} />
        <ListItemSecondaryAction>
          <IconButton aria-label="Delete" disabled={unAuthorized} onClick={() => onRemoveSelectedEntryDocumentations(doc, index)}>
              <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </Grid>
  );
};

export default withStyles(styles)(Document);



// WEBPACK FOOTER //
// ./src/components/entries/Document.js